<template>
  <div v-loading="loading">
    <div class="news-warp">
      <div class="news-container">
        <adv-item :adv-postion-name="advPostionName.top" />
        <div class="div-layout pd0">
          <div class="breadcrumb">
            <router-link :to="{ name: 'Home'}">
              首页
            </router-link> >
            <router-link :to="{ name: submetu.link , params: { id: submetu.params}}">
              {{ submetu.title }}
            </router-link>
            > {{ data.detail.title }}
            <span class="right printerIcon" @click="preview"><i class="el-icon-printer" />打印</span>
          </div>

          <div class="articleSource">
            <div class="title">
              {{ data.detail.title }}
            </div><span>发布日期：{{ data.detail.createDate }}</span><span v-show="data.detail.source">来源：{{ data.detail.source }}</span>
          </div>
          <div ref="print" class="text">
            <div id="detailContent" />
          </div>
        </div>
      </div>
      <adv-item :adv-postion-name="advPostionName.bottom" />
    </div>
  </div>
</template>
<script>
import getContent from '@/api/content';
export default {
  name: 'Detail',
  components: {
  },
  data: () => {
    return {
      loading: true,
      submetu: { title: '', link: '' },
      data: {
        id: '',
        interface: '',
        detail: ''
      },
      advPostionName: { top: '', bottom: '' }
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.data.id = route.params.id;
        this.switchSource(route.query.source);
        this.getDetail();
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    switchSource(val) {
      switch (val) {
        case 'announcement':
          this.submetu.title = '活动公告';
          this.submetu.link = 'Announcement';
          this.data.interface = 'geteduNoticeContentsDetail';
          this.advPostionName = {
            top: 'detail_notice_top_0',
            bottom: 'detail_notice_bottom_0'
          };
          break;
        case 'news':
          this.submetu.title = '资讯';
          this.submetu.link = 'News';
          this.submetu.params = 'all';
          this.data.interface = 'geteduInformationDetail';
          this.advPostionName = {
            top: 'detail_information_top_0',
            bottom: 'detail_information_bottom_0'
          };
          break;
        case 'qualityeducation':
          this.submetu.title = '素质教育专区';
          this.submetu.link = 'Qualityeducation';
          this.data.interface = 'geteduResourceContentsDetail';
          this.advPostionName = {
            top: 'detail_resource_top_0',
            bottom: 'detail_resource_bottom_0'
          };
          break;
        case 'schoolnews':
          this.submetu.title = '校园动态';
          this.submetu.link = 'Schoolnews';
          this.submetu.params = 'all';
          this.data.interface = 'getSchoolnewsDetail';
          this.advPostionName = {
            top: 'detail_resource_top_0',
            bottom: 'detail_resource_bottom_0'
          };
          break;
        default:
          break;
      }
    },
    getDetail() {
      // 获取详情
      this.loading = true;
      getContent[this.data.interface](this.data.id)
        .then(res => {
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.data.detail = '';
          } else {
            this.data.detail = res.data;
            document.getElementById('detailContent').innerHTML = this.data.detail.content;
          }
          this.loading = false;
        });
    },
    // 打印功能
    preview() {
      this.$print(this.$refs.print);
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.news-warp{
  .news-container{
    background-color: #f0f2f5;
    margin-top: 20px;
  }
  .breadcrumb{
     padding: 20px 40px;
    border-bottom: 1px solid #f4f4f4;
    }
    .printerIcon{
      i{
        font-size: 20px;
        margin-right: 4px;
      }
      color: #007AFC;
      cursor: pointer;
      &:hover{
        color: #1795FF;
      }
    }
  .title{
      font-size: 18px;
    font-weight: bold;
    padding: 20px;
    padding-bottom: 8px;
    }
    .articleSource{
      text-align: center;
      span{
        color: #999;
        padding: 10px;
        i{
          font-size: 20px;
          padding-right: 5px;
        }
      }
    }
    .text{
      padding: 40px;
    }
    #detailContent{line-height: 2;}
}

</style>
